@if (shouldUpload()) {
  <app-upload
    [disabled]="disabled()"
    [multi]="true"
    [uploadFn]="uploadFn"
    [maxFileSize]="maxFileSize()"
    [allowedMimeTypes]="allowedMimeTypes()" />
}

<div class="mt-3">
  <app-multimedia-grid-layout
    templateColumns="sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-3 2xl:grid-cols-4">
    @for (item of uploadQueue(); track item.name) {
      <app-multimedia-grid-layout-item>
        <app-multimedia-tile mode="loading" />
      </app-multimedia-grid-layout-item>
    }

    @for (id of uploaded(); track id) {
      @if (id | fetchWarehouseMultimediaById | async; as multimedia) {
        <app-multimedia-grid-layout-item>
          <app-multimedia-tile
            (removeClickEvent)="handleRemoveClickEvent(id)"
            [info]="shouldShowInfo(multimedia)"
            [type]="multimedia.type"
            [alt]="multimedia.alt"
            [filename]="multimedia.filename"
            [size]="multimedia.size"
            [downloadUrl]="multimedia.downloadUrl"
            [previewUrl]="multimedia.thumbnailPreviewUrl"
            [extension]="multimedia.extension"
            mode="remove" />
        </app-multimedia-grid-layout-item>
      } @else {
        <app-multimedia-grid-layout-item>
          <app-multimedia-tile mode="loading" />
        </app-multimedia-grid-layout-item>
      }
    }
  </app-multimedia-grid-layout>
</div>
